export default __webpack_public_path__ + "static/media/discordDeskFill.3300bd23.svg";